import Vue from 'vue'
import Router from 'vue-router'
import utils from '../plugins/utils'
import { Message } from 'element-ui'
import {pageTitle} from './seo'
import axios from 'axios'
import store from '../store'
import { initThemeColor, changeThemeColor } from '@/plugins/themeColorClient'

Vue.use(Router)

const chunkPath = (path, folder, name, meta) => {
  return {
      path,
      name: name ? name : path,
      meta: meta ? meta : {},
      component: () => import(/* webpackChunkName: "[request][index]" */ `../${folder}.vue`)
  }

}

// console.log(chunkPath('/', 'shops/shop'));

const router = new Router({
  mode:'history',
  routes: [
    {
      ...chunkPath('/blog-home', 'shops/beian/index', 'beian')
    },
    {
      ...chunkPath('/', 'shops/shop'),
      children: [
        chunkPath('/', 'shops/index/index', 'index'),
        {
          ...chunkPath('/giftShop', 'shops/product/giftShop'),
          children: [
            chunkPath('shopDetail/:goodinfo', 'shops/product/goodDetail', 'shopDetail'),
            chunkPath('', 'shops/product/allGoods', 'shopGoods')
          ]
        },
        chunkPath('/priceIntro', 'shops/intro/priceIntro', 'priceIntro'),
        {
          ...chunkPath('/tool', 'shops/tool/index'),
          children: [
            chunkPath('', 'shops/tool/guess/index'),
            chunkPath('foreign', 'shops/tool/foreign/index'),
            chunkPath('firstScreen', 'shops/tool/firstScreen/index'),
            chunkPath('similar', 'shops/tool/similar/index'),
            chunkPath('goodShop', 'shops/tool/goodShop/index'),
            chunkPath('mirror', 'shops/tool/mirror/index'),
            chunkPath('blackLibrary', 'shops/tool/blackLibrary/index'),
          ]
        },
        chunkPath('/useGuide', 'shops/intro/useGuide', 'useGuide'),
        {
          ...chunkPath('/user', 'shops/admin/admin'),
          children: [
            chunkPath('', 'shops/admin/userCenter', 'userCenter'),
            chunkPath('order/checkOrder', 'shops/admin/checkOrder', 'checkOrder'),
            chunkPath('info/vipcenter', 'shops/admin/vipcenter', 'vipcenter'),
            chunkPath('inviteRecord', 'shops/admin/inviteRecord', 'inviteRecord'),
            //   TODO: hide
            // chunkPath('storeManage', 'shops/admin/storeManage', 'storeManage'),
            chunkPath('order/checkPackage', 'shops/admin/checkPackage', 'checkPackage'),
            chunkPath('pay/ticketDetail', 'shops/admin/ticketDetail', 'ticketDetail'),
            chunkPath('pay/accountPay', 'shops/admin/accountPay', 'accountPay'),
            chunkPath('noGoods', 'shops/admin/noGoods', 'noGoods'),
          ]
        },
        chunkPath('/myCart', 'shops/cartpay/myCart', 'myCart'),
        chunkPath('/singleDelivery', 'shops/cartpay/singleShipment', 'singleShip'),
        chunkPath('/orderPay', 'shops/cartpay/orderPay', 'orderPay'),
      ]
    },
    {
      ...chunkPath('/admin', 'manage/base'),
      children: [
        chunkPath('', 'manage/components/shopM', 'shopM'),
        chunkPath('manage/shopList', 'manage/components/shopList', 'shopList'),
        chunkPath('manage/myOrder', 'manage/components/myOrder', 'myOrder'),
        chunkPath('manage/packageList', 'manage/components/packageList', 'packageList'),
        chunkPath('manage/inviteList', 'manage/components/inviteList', 'inviteList'),
        chunkPath('website/webSet', 'manage/components/webSet', 'webSet'),
        chunkPath('website/priceSet', 'manage/components/priceSet', 'priceSet'),
        chunkPath('website/goodsList', 'manage/components/goodsList', 'goodsList'),
      ]
    },
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.query.aff) {
    localStorage.aff = to.query.aff
  }
  if (to.query.spm) {
    localStorage.spm = to.query.spm
    axios({
        method: 'post',
        url: '/crmlog/v1/visit',
        baseURL: '/',
        data: {
            promotion_code: to.query.spm
        }
    });
  }
  if (localStorage.theme_color) {
    initThemeColor()
  }
  if (Object.keys(store.state.configData).length == 0) {
    await store.dispatch('getSiteInfo')
    if (store.state.configData.id != 1 && store.state.configData.color) {
      changeThemeColor(store.state.configData.color)
    }
  }
  if (store.state.configData.id != 1 && store.state.configData.name) {
    document.title = (pageTitle(to.path).replace(/大麦家/g, store.state.configData.name))
  } else {
    document.title = pageTitle(to.path)
  }
  // 处理标题
  if (window.location.href.includes('damaijia168.cn')) {
    document.title = '蓝天白云'
  }
  if (store.state.configData.id != 1 && store.state.configData.logo) {
    let favicon = document.head.querySelector("link")
    favicon.href = store.state.configData.logo
  }

  const needLoginRoute = ['priceIntro', '/user']
  if (!localStorage.dmjAuthor) {
    if (utils.hasString(to.path, needLoginRoute)) {
      Message.error('您需要登录')
      setTimeout(() => {
        window.openLogin()
      }, 1000);
      next(false)
      return
    }
  }

  if (to.path) {
      if (window._hmt) {
          window._hmt.push(['_trackPageview', '/#' + to.fullPath])
      }
  }
  next()
})

export default router
